import keto from "./keto.png";
import mediterranean from "./mediterranean.png";
import flexitarian from "./flexitarian.png";
import vegan from "./vegan.png";

export default { keto, mediterranean, flexitarian, vegan };
